import { useTranslation } from "react-i18next";
import "./loading-screen.css";

function LoadingScreen({ loading }) {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`loading-parent position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center transition ${
          loading ? "active" : ""
        }`}
        style={{ zIndex: 999999999999 }}
      >
        <div className="loader">
          <div className="circle bg-primary"></div>
          <div className="circle bg-primary"></div>
          <div className="circle bg-primary"></div>
          <div className="circle bg-primary"></div>
        </div>
        <p className="m-0 mt-3 fs-6 d-flex position-relative align-items-center text-white">
          {t("Loading")}..
        </p>
      </div>
    </>
  );
}

export default LoadingScreen;
